import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import FeedbackSettingsModal from '../components/FeedbackSettingsModal';
import { FEEDBACK_STATUS, TEMPLATE_NAMES, MODE_NAMES } from '../utils/feedback';

const FeedbackList = () => {
  const [forms, setForms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [creating, setCreating] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/feedback')
      .then(r => setForms(r.data))
      .catch(() => setError('Failed to load feedback forms'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="text-center mt-5">Loading...</div>;

  return (
    <div>
      <div className="flex flex-between flex-center mb-5">
        <div>
          <h1>Feedback</h1>
          <p className="text-muted">Trainees scan a QR code to give feedback on a training</p>
        </div>
        <button className="btn btn-primary" onClick={() => setCreating(true)}>+ New Feedback Form</button>
      </div>

      {error && <div className="alert alert-error mb-4">{error}</div>}

      {forms.length === 0 ? (
        <div className="card empty-state">
          <h3>No feedback forms yet</h3>
          <p>Create one for a training, then show its QR code at the end of the course</p>
          <button className="btn btn-primary mt-3" onClick={() => setCreating(true)}>Create Feedback Form</button>
        </div>
      ) : (
        <div className="card" style={{ padding: 0 }}>
          <table className="table">
            <thead>
              <tr><th>Title</th><th>Training</th><th>Questions</th><th>Names</th><th>Status</th><th>Responses</th></tr>
            </thead>
            <tbody>
              {forms.map(f => (
                <tr key={f.id} style={{ cursor: 'pointer' }} onClick={() => navigate(`/feedback/${f.id}`)}>
                  <td><strong>{f.title}</strong></td>
                  <td className="text-sm text-muted">{f.training_title || f.category_name || '—'}</td>
                  <td className="text-sm">{TEMPLATE_NAMES[f.template]}</td>
                  <td className="text-sm">{MODE_NAMES[f.identity_mode]}</td>
                  <td><span className={`badge ${FEEDBACK_STATUS[f.status].className}`}>{FEEDBACK_STATUS[f.status].label}</span></td>
                  <td>{f.response_count}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {creating && (
        <FeedbackSettingsModal
          onClose={() => setCreating(false)}
          onSaved={(f) => navigate(`/feedback/${f.id}`)}
        />
      )}
    </div>
  );
};

export default FeedbackList;
